import { ActivityTypes } from "@/enums/models/activity-types"

export const activityTypes = [
  {
    key: ActivityTypes.BREAK,
    value: "Pauze"
  },
  {
    key: ActivityTypes.MAINTENANCE,
    value: "Onderhoud"
  }
]

export function activityTypeToName(type: ActivityTypes) {
  return activityTypes.find((activity) => activity.key.toString() === type.toString())!.value
}
